import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
import { MetaTagService } from 'src/app/shared/services/MetaTagService/meta-tag.service';

@Component({
  selector: 'app-articale-table',
  templateUrl: './articale-table.component.html',
  styleUrls: ['./articale-table.component.css'],
})
export class ArticaleTableComponent implements OnInit, OnDestroy {  
  language!: string;
  components: any[] = [];
  mainData: any;
  articles: any;
  routeSub!: Subscription;   

  constructor(
    private route: ActivatedRoute,
    private metaTagService:MetaTagService
  ) {}

  ngOnInit() {        
    this.language = this.route.snapshot.url[0].path
    
    this.routeSub = this.route.params.subscribe(params => {
      if (params['lang']) {
        this.language = params['lang'];
        this.getResolverData();        
      }
    });               
    this.getResolverData();        
  }

  getResolverData(){
    const resolverData = this.route.snapshot.data['article'];        
    if (resolverData) {            
      this.articles = resolverData.data;      
      this.metaTagService.updateMetaTags(resolverData.meta.meta);
    } else {
      console.error("Resolver data is undefined");
    }
  }  

  getLink(service: any) {        
    return (
      '/' +
      this.language +
      '/details/articles/articles/' +            
      service.title.replaceAll(' ', '-').toLowerCase()
    );
  }

  ngOnDestroy(): void {   
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
